/**
 * @module actions/auth
 */
import axios from 'axios'
import { setAuthorizationToken, setDeviceToken } from '../utils/setAuthorizationToken'
import {
  API_URL,
  SET_CURRENT_USER,
  SET_USER_PERMISSIONS,
  SET_CUSTOMERS,
  SET_COMPANIES,
  SET_DEFAULT_PHONECODE,
  SET_DEFAULT_LANGUAGE,
  LOGIN_AS_USER,
  SET_EMPLOYEES,
  SET_WORKSCREEN,
  SET_ACCOUNTING_TYPE,
  SET_HAS_PARTNER,
  SET_COMPANY_HAVE_ASSIGNED_ESG,
  // SET_ALLOWCARRENTALOVERVIEW,
  SET_DEPARTMENT_TYPE,
  SET_ALLOW_CHANGE_DELIVERY,
  SET_ALLOW_NO_CUSTOMER,
  SET_ORDERLIST_USE_TIME_PICUP,
  SET_SHOP_ACTIVE_PUNCHCLOCK,
  SET_NEW_ORDERS_GROUPING,
  RESET_SIMPLESEARCH,
  RESET_SIMPLESEARCH_WORKSCREEN,
  // RESET_ORDER_FILTER,
  RESET_ORDERLIST_FILTER,
  RESET_WORKSCREEN_ORDER_FILTER,
  RESET_CUSTOMER_ORDER_FILTER,
  RESET_WP_ORDER_FILTER,
  SET_PREV_WORKSCREEN,
  UPDATE_TASKS_WORKSCREEN,
  SET_CURRENCY_CODE,
  SET_HAS_PAINT_PARTNER,
  SET_CAR_RENTALSYSTEM_TYPE,
  SET_BODY_DEFAULT_LEAD_TIME
} from '../constants'
import { SetWorkscreenOrders } from './orders'
import EventEmitter from '../utils/events'

import { setLanguageAction } from '../language/actions'

/**
 * @description Returns payload for dispatching SET_CURRENT_USER
 * @param {Object} user Object containing user data
 */
export function setCurrentUser (user) {
  return {
    type: SET_CURRENT_USER,
    user
  }
}
export function setPrevWorkscreen (workscreen) {
  // console.log('[actions/auth] setPrevWorkscreen', workscreen)
  return {
    type: SET_PREV_WORKSCREEN,
    prevWorkscreen: workscreen
  }
}

export function setDepartmentType (departmentType) {
  return {
    type: SET_DEPARTMENT_TYPE,
    departmentType: departmentType
  }
}
/**
 * @description Logs out user by removing localstorage data, removing Axios authorization and dispatching setCurrentUser with empty Object
 */
export function logout () {
  return dispatch => {
    window.localStorage.removeItem('user_token')
    window.localStorage.removeItem('user_data')
    window.localStorage.removeItem('user_language')
    window.localStorage.removeItem('inactiveUsers')
    window.localStorage.removeItem('loginAsUser')
    window.localStorage.removeItem('filterOrderlist')
    window.localStorage.removeItem('filterWorkscreen')
    window.localStorage.removeItem('filterCustomer')
    window.localStorage.removeItem('filterWP')
    window.localStorage.removeItem('simpleSearch')
    window.localStorage.removeItem('simplesearchWorkscreen')
    window.localStorage.removeItem('carRentalOverviewSettings')
    // window.localStorage.setItem('workscreen_view', null)
    setAuthorizationToken(false)
    setDeviceToken(false)
    dispatch(setCurrentUser({}))
    dispatch({
      type: RESET_SIMPLESEARCH
    })
    dispatch({
      type: RESET_SIMPLESEARCH_WORKSCREEN
    })
    // dispatch({
    //   type: RESET_ORDER_FILTER
    // })
  }
}

/**
 * @description Logs in user by adding localstorage data, setting Axios authorization and dispatching setCurrentUser with user object
 * @param  {Object} data Object that will be posted to url
 */
export function login (data) {
  return dispatch => {
    window.localStorage.clear()
    // console.log('cleared local storage')
    return axios.post(API_URL + '/Users/Login/', data).then(res => {
      const token = res.data.Token
      window.localStorage.setItem('user_token', token)
      window.localStorage.setItem('user_data', JSON.stringify(res.data))
      // window.localStorage.setItem('department_type', JSON.stringify(res.data.DepartmentType))
      // window.localStorage.setItem('user_language', 'English')
      window.localStorage.removeItem('CapacityOverviewfilter')
      setAuthorizationToken(token)
      setDeviceToken(res.data.DeviceToken)
      dispatch(setCurrentUser(res.data))
      dispatch({
        type: RESET_SIMPLESEARCH
      })
      // reset filters
      if (res.data.UserType === 4) { // customer
        dispatch({
          type: RESET_CUSTOMER_ORDER_FILTER
        })
      } else if (res.data.UserType === 6) { // wp
        dispatch({
          type: RESET_WP_ORDER_FILTER
        })
      } else { // shop
        dispatch({
          type: RESET_SIMPLESEARCH_WORKSCREEN
        })
        dispatch({
          type: RESET_ORDERLIST_FILTER
        })
        dispatch({
          type: RESET_WORKSCREEN_ORDER_FILTER
        })
      }
      // dispatch({
      //   type: RESET_ORDER_FILTER
      // })

      return res
    })
  }
}

/**
 * @description Returns payload for dispatching SET_USER_PERMISSIONS
 */
function setUserPermissions (permissions) {
  return {
    type: SET_USER_PERMISSIONS,
    permissions
  }
}

function setAccountingType (AccountingSystem) {
  return {
    type: SET_ACCOUNTING_TYPE,
    accountingSystem: AccountingSystem
  }
}

function setCarRentalSystemType (CarRentalSystem) {
  return {
    type: SET_CAR_RENTALSYSTEM_TYPE,
    carRentalSystem: CarRentalSystem
  }
}

function setWorkscreen (Workscreen) {
  return {
    type: SET_WORKSCREEN,
    myscreen: Workscreen
  }
}

function setCustomers (Customers) {
  return {
    type: SET_CUSTOMERS,
    customers: Customers
  }
}

function setCompanies (Companies) {
  return {
    type: SET_COMPANIES,
    companies: Companies
  }
}

function setEmployees (Employees) {
  return {
    type: SET_EMPLOYEES,
    employees: Employees
  }
}

function setDefaultPhonecode (Phonecode) {
  return {
    type: SET_DEFAULT_PHONECODE,
    phonecode: Phonecode
  }
}

function setDefaultLanguage (Language) {
  return {
    type: SET_DEFAULT_LANGUAGE,
    language: Language
  }
}

function setCurrencyCode (CurrencyCode) {
  return {
    type: SET_CURRENCY_CODE,
    currencyCode: CurrencyCode
  }
}

function setHasPaintPartner (HasPaintPartner) {
  return {
    type: SET_HAS_PAINT_PARTNER,
    hasPaintPartner: HasPaintPartner
  }
}

function setBodyShopDefaultLeadTime (BodyShopDefaultLeadTime) {
  return {
    type: SET_BODY_DEFAULT_LEAD_TIME,
    bodyShopDefaultLeadTime: BodyShopDefaultLeadTime
  }
}

function setHasPartner (hasPartner, partnerName, partnerForsiBodyShopId) {
  return {
    type: SET_HAS_PARTNER,
    hasPartner: hasPartner,
    partnerName: partnerName,
    partnerForsiBodyShopId: partnerForsiBodyShopId
  }
}

function setAllowChangeDelivery (customerAllowChangeDelivery) {
  return {
    type: SET_ALLOW_CHANGE_DELIVERY,
    customerAllowChangeDelivery: customerAllowChangeDelivery
  }
}

function setAllowNoCustomer (allowNoCustomer) {
  return {
    type: SET_ALLOW_NO_CUSTOMER,
    payload: allowNoCustomer || false
  }
}

function setOrderlistUseTimePickup (useTimeForPickup) {
  return {
    type: SET_ORDERLIST_USE_TIME_PICUP,
    shopUseTimeForPickupOnOrderList: useTimeForPickup
  }
}

function setShopActivePunchclock (isActive) {
  return {
    type: SET_SHOP_ACTIVE_PUNCHCLOCK,
    shopPunchClockActive: isActive
  }
}

function setNewOrdersGrouping (grouping) {
  return {
    type: SET_NEW_ORDERS_GROUPING,
    grouping: grouping
  }
}

function setCompanyHaveAssignedESG (haveESGAssign) {
  return {
    type: SET_COMPANY_HAVE_ASSIGNED_ESG,
    companyHaveAssignedESG: haveESGAssign
  }
}

/**
 * @description Gets the resources for logged in users
 */
export function getAuthResources () {
  return dispatch => {
    return axios.get(API_URL + '/Resources/Token/Get').then((res) => {
      dispatch(setUserPermissions(res.data.Permissions))
      if (!res.data.MyWorkScreen.Active) {
        let storedview = Number(window.localStorage.getItem('workscreen_view'))
        if (!isNaN(storedview) && storedview === 7) {
          window.localStorage.setItem('workscreen_view', null)
          EventEmitter.emit('WORKSCREEN_VIEW_CHANGED', null)
        }
        let storedDepartment = parseInt(window.localStorage.getItem('department_type'))
        if (parseInt(storedDepartment) !== parseInt(res.data.ShopDepartment)) {
          let view = '1'
          switch (parseInt(res.data.ShopDepartment)) {
            case 0:
              view = '0'
              break
            case 1:
              view = '2'
              break
            case 2:
              view = '1'
              break
          }
          storedview = view
        }
        window.localStorage.setItem('workscreen_view', storedview)
      } else {
        window.localStorage.setItem('workscreen_view', '7')
        EventEmitter.emit('WORKSCREEN_VIEW_CHANGED', '7')
      }
      // To prevent department type to be default value for a moment on brower update
      if (parseInt(window.localStorage.getItem('department_type')) !== res.data.ShopDepartment) {
        window.localStorage.setItem('department_type', JSON.stringify(res.data.ShopDepartment))
      }
      dispatch(setAccountingType(res.data.AccountingSystem))
      dispatch(setCarRentalSystemType(res.data.CarRentalSystem))
      dispatch(setWorkscreen(res.data.MyWorkScreen))
      dispatch(setCustomers(res.data.Customers))
      dispatch(setCompanies(res.data.Companies))
      dispatch(setEmployees(res.data.Employees))
      dispatch(setDefaultPhonecode(res.data.DefaultPhoneCode))
      dispatch(setDefaultLanguage(res.data.DefaultLanguage))
      dispatch(setHasPartner(res.data.HasPartner, res.data.PartnerName, res.data.PartnerForsiBodyShopId))
      dispatch(setDepartmentType(res.data.ShopDepartment))
      dispatch(setAllowChangeDelivery(res.data.CustomerAllowChangeDelivery))
      dispatch(setAllowNoCustomer(res.data.AllowNoCustomer))
      dispatch(setOrderlistUseTimePickup(res.data.ShopUseTimeForPickupOnOrderList))
      dispatch(setShopActivePunchclock(res.data.ShopPunchClockActive))
      dispatch(setNewOrdersGrouping(res.data.NewOrdersGrouping))
      dispatch(setCurrencyCode(res.data.CurrencyCode))
      dispatch(setHasPaintPartner(res.data.HasPaintPartner))
      dispatch(setBodyShopDefaultLeadTime(res.data.BodyShopDefaultLeadTime))
      dispatch(setCompanyHaveAssignedESG(res.data.CompanyHaveAssignedESG))
      if (!window.localStorage.user_language) {
        window.localStorage.setItem('user_language', res.data.DefaultLanguage)
        dispatch(setLanguageAction(res.data.DefaultLanguage))
      }
      return res
    })
  }
}

/**
 * @description Changes the password for user
 */
export function changePassword (data) {
  let url = API_URL + '/Users/ChangePassword'
  return dispatch => {
    return axios.post(url, data)
  }
}

export function changePasswordByToken (token, newPassword) {
  let url = API_URL + '/Users/ChangePasswordByToken'
  let data = { Token: token, NewPassword: newPassword }
  return dispatch => {
    return axios.post(url, data)
  }
}

export function validatePasswordResetToken (token) {
  let url = API_URL + '/Users/ValidatePasswordResetToken/' + token
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Changes or sets the pincode for user
 */
export function changePincode (data) {
  let url = API_URL + '/Users/ChangePincode'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Check if ActivationToken exist
 */
export function checkActionToken (data) {
  let url = API_URL + '/Users/Token'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Post ActivationToken data
 */
export function submitActionToken (data) {
  let url = API_URL + '/Users/Token/Activate'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Login as another user
 */
export function loginAs (userId, CompanyId, support, impersonate, pinCode) {
  console.log('Called loginAs...')
  CompanyId = (typeof CompanyId === 'undefined') ? 0 : CompanyId
  userId = (CompanyId > 0) ? 0 : userId
  let url = API_URL + '/Users/LoginAs'
  return dispatch => {
    return axios.post(url, {
      UserId: userId,
      CompanyId: CompanyId,
      Support: support,
      Impersonate: impersonate,
      PinCode: pinCode
    }).then((res) => {
      setAuthorizationToken(res.data.Token)
      setDeviceToken(res.data.DeviceToken)
      var ord = []
      dispatch(SetWorkscreenOrders(ord))
      // Call /Api/Resources/Token
      setTimeout(() => {
        dispatch(getAuthResources())
      }, 50)
      setTimeout(() => {
        dispatch({
          type: LOGIN_AS_USER,
          user: res.data,
          companyId: CompanyId
        })
        EventEmitter.emit(UPDATE_TASKS_WORKSCREEN)
      }, 100)
      window.localStorage.removeItem('filterOrderlist')
      window.localStorage.removeItem('filterWorkscreen')
      window.localStorage.removeItem('filterCustomer')
      window.localStorage.removeItem('filterWP')
      window.localStorage.removeItem('simpleSearch')
      window.localStorage.removeItem('simplesearchWorkscreen')
      window.localStorage.removeItem('CapacityOverviewfilter')
      setTimeout(() => {
        dispatch({
          type: RESET_SIMPLESEARCH
        })
        dispatch({
          type: RESET_SIMPLESEARCH_WORKSCREEN
        })
        // reset filters
        if (res.data.UserType === 4) { // customer
          dispatch({
            type: RESET_CUSTOMER_ORDER_FILTER
          })
        } else if (res.data.UserType === 6) { // wp
          dispatch({
            type: RESET_WP_ORDER_FILTER
          })
        } else { // shop
          // console.log('RESET orderlist and workscreen filters')
          dispatch({
            type: RESET_ORDERLIST_FILTER
          })
          dispatch({
            type: RESET_WORKSCREEN_ORDER_FILTER
          })
        }
        // dispatch({
        //   type: RESET_ORDER_FILTER
        // })
        document.dispatchEvent(new window.CustomEvent('click', {bubbles: true, cancelable: false, view: window}))
      }, 150)
      return res
    })
  }
}

export function logOutAs (ToOriginalUser) {
  return (dispatch, getState) => {
    const { user, inactiveUsers } = getState().auth

    let last = inactiveUsers[inactiveUsers.length - 1]
    for (let i = inactiveUsers.length - 1; i >= 0; i--) {
      let inactiveUser = inactiveUsers[i]
      if (inactiveUser.UserType !== user.UserType) {
        last = inactiveUser
        break
      }
    }
    console.log('logOutAs', inactiveUsers, last)

    if (ToOriginalUser === true) {
      last = inactiveUsers[0]
    }
    if (last !== undefined) {
      last.hasLoggedInBefore = true
    }

    if (last.UserType === 7) last.PrevWorkscreenView = 0 // If shop owner login set workscreenView to "Full screen"

    // console.log('Log out - reset filters')
    // reset filters
    dispatch({ // customer
      type: RESET_CUSTOMER_ORDER_FILTER
    })
    dispatch({ // wp
      type: RESET_WP_ORDER_FILTER
    })
    dispatch({ // shop - orderlist
      type: RESET_ORDERLIST_FILTER
    })
    dispatch({ // shop - workscreen
      type: RESET_WORKSCREEN_ORDER_FILTER
    })

    // console.log('logout to', last)
    setAuthorizationToken(last.Token)
    setDeviceToken(last.DeviceToken)
    dispatch(setCurrentUser(last))
    dispatch(setPrevWorkscreen(last.PrevWorkscreenView))
    dispatch({
      type: LOGIN_AS_USER,
      user: null,
      newUser: last
    })
    dispatch({
      type: RESET_SIMPLESEARCH
    })
    dispatch({
      type: RESET_SIMPLESEARCH_WORKSCREEN
    })
    // dispatch({
    //   type: RESET_ORDER_FILTER
    // })
    // Call /Api/Resources/Token
    setTimeout(() => {
      dispatch(getAuthResources())
    }, 50)
    return Promise.resolve()
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/auth.js